




















































import {Component, Mixins} from 'vue-property-decorator';
import DialogMixin from '@/mixins/DialogMixins';

@Component({
  inheritAttrs: false,
})
export default class DeleteDialog extends Mixins(DialogMixin) {
  private deleting = false;
  private errorMsg: string | null = null;

  onOk() {
    if (this.errorMsg) return this.close();

    if (this.options.deleteCallback && typeof this.options.deleteCallback === 'function') {
      this.deleting = true;
      this.options.deleteCallback(this.data);
    }
  }

  onBtn2() {
    this.$emit('onBtn2Click', this.data);
  }

  error(msg: string) {
    this.errorMsg = msg;
    this.deleting = false;
  }

  clear() {
    this.deleting = false;
    this.data = null;
    this.errorMsg = null;
  }
}
